module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/back icon-78b489b9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/back icon.svg
// module id = ./app/web/src/assets/back icon.svg
// module chunks = 0